/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdOperatorOverviewForFleetsQueryVariables = Types.Exact<{
  regionId: Types.Scalars['ID']['input']
  role?: Types.InputMaybe<Types.FccOperatorRoleType>
}>

export type AdOperatorOverviewForFleetsQuery = {
  __typename?: 'Query'
  fleetAvailabilities: Array<{
    __typename?: 'FccOperatorAvailabilityByFleet'
    fleetId: string
    availabilities: {
      __typename?: 'FccOperatorAvailabilities'
      busy: number
      available: number
    }
  }>
}

export const AdOperatorOverviewForFleetsDocument = gql`
    query AdOperatorOverviewForFleets($regionId: ID!, $role: FccOperatorRoleType) {
  fleetAvailabilities: fccOperatorAvailabilitiesByFleets(
    regionId: $regionId
    role: $role
  ) {
    fleetId
    availabilities {
      busy
      available
    }
  }
}
    `

/**
 * __useAdOperatorOverviewForFleetsQuery__
 *
 * To run a query within a React component, call `useAdOperatorOverviewForFleetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdOperatorOverviewForFleetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdOperatorOverviewForFleetsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAdOperatorOverviewForFleetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  > &
    (
      | { variables: AdOperatorOverviewForFleetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  >(AdOperatorOverviewForFleetsDocument, options)
}
export function useAdOperatorOverviewForFleetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  >(AdOperatorOverviewForFleetsDocument, options)
}
// @ts-ignore
export function useAdOperatorOverviewForFleetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorOverviewForFleetsQuery,
  AdOperatorOverviewForFleetsQueryVariables
>
export function useAdOperatorOverviewForFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorOverviewForFleetsQuery,
        AdOperatorOverviewForFleetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdOperatorOverviewForFleetsQuery | undefined,
  AdOperatorOverviewForFleetsQueryVariables
>
export function useAdOperatorOverviewForFleetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdOperatorOverviewForFleetsQuery,
        AdOperatorOverviewForFleetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdOperatorOverviewForFleetsQuery,
    AdOperatorOverviewForFleetsQueryVariables
  >(AdOperatorOverviewForFleetsDocument, options)
}
export type AdOperatorOverviewForFleetsQueryHookResult = ReturnType<
  typeof useAdOperatorOverviewForFleetsQuery
>
export type AdOperatorOverviewForFleetsLazyQueryHookResult = ReturnType<
  typeof useAdOperatorOverviewForFleetsLazyQuery
>
export type AdOperatorOverviewForFleetsSuspenseQueryHookResult = ReturnType<
  typeof useAdOperatorOverviewForFleetsSuspenseQuery
>
export type AdOperatorOverviewForFleetsQueryResult = Apollo.QueryResult<
  AdOperatorOverviewForFleetsQuery,
  AdOperatorOverviewForFleetsQueryVariables
>
